export const PROJECT_CHART_FONT = "Poppins, sans-serif";
export const PROJECT_CHART_FONT_SIZE = 12;
export const PROJECT_CHART_PADDING = Object.freeze({ top: 4, right: 12, bottom: 18, left: 8 });
